// The /ai/ endpoint attributes anonymous chat usage by IP (no session to key
// on before authentication), so every request needs the visitor's public IP.
// Fetched once per page load and cached — it doesn't change between messages.
let cachedIp: Promise<string> | null = null

export const getClientIp = (): Promise<string> => {
  if (!cachedIp) {
    cachedIp = fetch('https://api.ipify.org?format=json')
      .then((response) => response.json())
      .then((data) => data.ip as string)
      .catch(() => '')
  }
  return cachedIp
}
